export default "__VITE_ASSET__Bl0iSU3E__"